import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/ApiService'

class Platforms extends Component {
    constructor() {
        super()
        this.state = {
            platformsList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getPlatformsList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getPlatformsList = () => {
        apiService.getPlatformsDetailList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        platformsList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.platformsList).map((value,index) => {
            
            return {
                label : this.state.platformsList[value],
                value :  this.state.platformsList[value]
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Platform"
                options={list}
                onChange={(e) => { (e) ? this.props.platformChange(e) : this.props.platformChange([])}}
                />
            </div>
        )
    }
}
export default Platforms


// WEBPACK FOOTER //
// ./src/common/DropDowns/Platforms.js